/** Cross-subscription flags: overlapping services in "pick one" categories. */

import type { Subscription } from '../types';
import { OVERLAP_CATEGORIES } from '../merchants/data';
import type { MoneyFormatter } from './format';

export function addOverlapFlags(subs: Subscription[], money: MoneyFormatter): void {
  for (const cat of OVERLAP_CATEGORIES) {
    const inCat = subs.filter((s) => s.status === 'active' && s.category === cat);
    if (inCat.length < 2) continue;
    const total = inCat.reduce((a, s) => a + s.monthlyCost, 0);
    const cheapest = Math.min(...inCat.map((s) => s.monthlyCost));
    for (const s of inCat) {
      s.flags.push({
        type: 'overlap',
        label: `${inCat.length} in ${cat}`,
        detail:
          `You pay ${money(total)}/mo across ${inCat.length} ${cat.toLowerCase()} services ` +
          `(${inCat.map((x) => x.name).join(', ')}). Keeping one could save up to ${money(total - cheapest)}/mo.`,
        savings: 0,
      });
    }
  }
}
